export const swlog = (message: string, error?: Error): void => {
  const _message = `SW[${new Date().toISOString()}] ` + message;
  error !== undefined ? console.error("%s", _message, error) : console.log("%s", _message);
};
